import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const PublicRoute = ({ children }) => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  console.log(localStorage.getItem("redirecturl"))
  const redirectUrl = localStorage.getItem("redirecturl") || '/profile/profile';
  
  if (isAuthenticated) {

    
    return <Navigate to={redirectUrl} replace />;
  }

  return <Outlet />; 
};

export default PublicRoute;
